import { useEffect, useState } from 'react';
// import { useListContext } from 'react-admin';
import { Box } from '@mui/material';
import { isEqual } from 'lodash';
import { DragDropContext } from '@hello-pangea/dnd';

import TaskColumn from './TaskColumn';
import statuses, { getTasksByStatus } from './statuses';


const TaskListContent = (props) => {
    // const { data: unorderedTasks, isLoading } = useListContext(props.data);
    const isLoading = false;
    const unorderedTasks = props?.data || [];

    const [tasksByStatus, setTasksByStatus] = useState(getTasksByStatus([]));

    useEffect(() => {
        if (unorderedTasks) {
            const newTasksByStatus = getTasksByStatus(unorderedTasks);
            if (!isEqual(newTasksByStatus, tasksByStatus)) {
                setTasksByStatus(newTasksByStatus);
            }
        }
    }, [unorderedTasks]); // eslint-disable-line react-hooks/exhaustive-deps

    if (isLoading) return null;

    const onDragEnd = async () => {
        
    };

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Box display="flex" width="100%">
                {statuses.map((status) => (
                    <TaskColumn
                        status={status}
                        tasks={tasksByStatus[status]}
                        key={status}
                    />
                ))}
            </Box>
        </DragDropContext >
    );
};

export default TaskListContent;